const RESERVED_SUBDOMAINS = new Set([
  'admin',
  'api',
  'app',
  'www',
  'vetesuite'
]);

const ENV_TENANT_ID =
  process.env.REACT_APP_TENANT_ID ||
  process.env.REACT_APP_TENANT_UUID ||
  process.env.REACT_APP_TENANT_KEY ||
  '';
const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';

function tenantFromHostname() {
  if (typeof window === 'undefined') {
    return '';
  }

  const hostname = window.location.hostname.toLowerCase();

  if (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.endsWith('.local')
  ) {
    return '';
  }

  if (!hostname.endsWith('.vetesuite.com')) {
    return '';
  }

  const subdomain = hostname.replace(/\.vetesuite\.com$/, '').split('.')[0];

  if (!subdomain || RESERVED_SUBDOMAINS.has(subdomain)) {
    return '';
  }

  return subdomain;
}

export function getRuntimeTenantId() {
  if (ENV_TENANT_ID) {
    return ENV_TENANT_ID;
  }

  const hostTenant = tenantFromHostname();
  if (hostTenant) {
    return hostTenant;
  }

  if (typeof window === 'undefined') {
    return '';
  }

  if (!IS_DEVELOPMENT) {
    return '';
  }

  return window.localStorage.getItem('vetesuite_admin_tenant_id') || '';
}

export function isRuntimeTenantFixed() {
  return Boolean(ENV_TENANT_ID || tenantFromHostname());
}

export function canUseLocalTenantSelector() {
  return IS_DEVELOPMENT && !isRuntimeTenantFixed();
}

export function setRuntimeTenantId(tenantId) {
  if (typeof window === 'undefined') {
    return;
  }

  if (!IS_DEVELOPMENT) {
    return;
  }

  const normalized = String(tenantId || '').trim();

  if (normalized) {
    window.localStorage.setItem('vetesuite_admin_tenant_id', normalized);
  } else {
    window.localStorage.removeItem('vetesuite_admin_tenant_id');
  }
}
